<template>
  <el-select
    v-model="storeModel"
    :placeholder="$t('button.search')"
    :remote-method="getStores"
    remote
    filterable
    @change="handleStoreChange"
  >
    <el-option
      v-for="item in stores"
      :key="item.slug"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import { createComponent, ref, watch, onMounted } from '@vue/composition-api'

import VaderService from '../api/vader'
import VaderUtils from '../utils/vader'

const ProductSearchBox = createComponent({
  props: {
    store: {
      type: [Number, String],
      default: null,
    },
    initialSearch: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const storeModel = ref(null)
    watch(() => {
      if (storeModel.value) {
        emit('update:store', storeModel.value)
      }
    })
    const handleStoreChange = (v) => {
      emit('change', v)
    }

    const stores = ref([])
    const getStores = async (keywords) => {
      try {
        const { data } = await VaderService.getStores(keywords)
        stores.value = VaderUtils.handleStoreNameCollision(data.data)
        emit('search', { keywords, result: stores.value })
      } catch (error) {
        console.error(error);
      }
    }

    onMounted(() => {
      if (props.store) {
        storeModel.value = props.store
      }
      if (props.initialSearch) {
        getStores(props.initialSearch)
      }
    })

    return {
      // Data
      stores,
      storeModel,

      // Methods
      getStores,
      handleStoreChange,
    }
  },
})

export default ProductSearchBox
</script>
